import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useAppContext } from '../context/AppContext';
import { financialService } from '../utils/api';

function Experience() {
  const { state, actions } = useAppContext();
  const [timeoutDialogOpen, setTimeoutDialogOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [values, setValues] = useState({
    objective:     state.objective     || '',
    concerns:      state.concerns      || '',
    yearsInEquity: state.yearsInEquity || '',
  });

  useEffect(() => {
    setValues({
      objective:     state.objective     || '',
      concerns:      state.concerns      || '',
      yearsInEquity: state.yearsInEquity || '',
    });
  }, [state.objective, state.concerns, state.yearsInEquity]);

  const handleChange = (field) => (e) => {
    const val = e.target.value;
    setValues(prev => ({ ...prev, [field]: val }));
    actions.updateFormData(field, val);
  };

  const handleContinue = async () => {
    setIsSaving(true);

    try {
      await financialService.updateUserInfo(state.phoneNumber, {
        occupation:      state.occupation,
        employer:        state.employer,
        dependents:      state.dependents,
        city:            state.city,
        objective:       values.objective,
        concerns:        values.concerns,
        years_in_equity: values.yearsInEquity,
      });

      actions.nextStep();
    } catch (err) {
      console.error('updateUserInfo failed:', err);
      if (err?.response?.status === 401) {
        setTimeoutDialogOpen(true);
        setTimeout(() => window.location.reload(), 5000);
      } else {
        console.log('We could not save this information.');
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
          Investment Experience
        </Typography>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            What is your primary investment objective?
          </Typography>
          <TextField
            value={values.objective}
            onChange={handleChange('objective')}
            fullWidth
            placeholder="Fulfilling goals, wealth maximisation, etc."
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            What concerns do you have about your finances or investments?
          </Typography>
          <TextField
            value={values.concerns}
            onChange={handleChange('concerns')}
            fullWidth
            placeholder="Returns, Diversification, etc."
          />
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" gutterBottom>
            How many years have you been investing in the Equity Market?
          </Typography>
          <FormControl fullWidth>
            <Select
              value={values.yearsInEquity}
              onChange={handleChange('yearsInEquity')}
              displayEmpty
              inputProps={{ 'aria-label': 'Years in equity' }}
            >
              <MenuItem value=""><em>Select option</em></MenuItem>
              <MenuItem value="<3">{'< 3 years'}</MenuItem>
              <MenuItem value="3-5">3 – 5 years</MenuItem>
              <MenuItem value="5-10">5 – 10 years</MenuItem>
              <MenuItem value=">10">{'> 10 years'}</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Button
          variant="contained"
          color="success"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={handleContinue}
          disabled={isSaving}
          fullWidth
          sx={{ borderRadius: 1, py: 1.5, textTransform: 'none', fontWeight: 'bold' }}
        >
          {isSaving ? 'Saving...' : 'Continue'}
        </Button>
      </CardContent>

      <Dialog open={timeoutDialogOpen} onClose={() => {}} fullWidth maxWidth="xs">
        <DialogTitle>Session Timeout</DialogTitle>
        <DialogContent>
          <Typography>Your session expired. Reloading the page…</Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Experience;
